import ResultsList from 'components/ResultList'
import React from 'react'
import ReactDOM from 'react-dom'
import LocalContentView from 'widgets/LocalContent'
import LocalContentContainer from 'widgets/LocalContent/Container'
import LocalContentTemplateSwitch from 'widgets/LocalContent/TemplateSwitch'

const LocalContentPortal = ({ quicklinksAndDocuments }) => {
  // Define a container element for the portal
  const portalContainer = document.querySelector('.content-subfooter .content-subfooter__outer')

  // Render the LocalContentView component using createPortal
  const contentView = (
    <LocalContentView>
      <LocalContentContainer>
        {/* Result list */}
        {!!quicklinksAndDocuments.length && (
          <ResultsList
            documents={quicklinksAndDocuments}
            render={doc => (
              <LocalContentTemplateSwitch {...doc} key={ doc.title + doc.organization} />
            )}
          />
        )}
      </LocalContentContainer>
    </LocalContentView>
  );

  return portalContainer && ReactDOM.createPortal(contentView, portalContainer)
}

export default LocalContentPortal
